export enum AutomationMode {
  default = 'default',
  liveEdit = 'live_edit',
  commonReport = 'common_report',
  individualReport = 'individual_report',
}
